import { render } from "./StaffIndex.vue?vue&type=template&id=3c8e9d68"
import script from "./StaffIndex.vue?vue&type=script&lang=js"
export * from "./StaffIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__